import React from 'react';
import PropTypes from 'prop-types';

import { AccessConsumer } from './Context';

function getPermissionRule(permissions, rule) {
    if (typeof rule !== 'string') {
        throw Error('Permission rule is not defined');
    }

    const permission = permissions[rule];

    if (permission === undefined) {
        throw Error(`Permission ${rule} does not exist`);
    }

    return permission;
}

const AccessControl = ({ rule, children, renderNoAccess, params }) => {
    return (
        <AccessConsumer>
            {permissions => {
                if (!permissions) {
                    return null;
                }

                const ruleFn = getPermissionRule(permissions, rule);

                return ruleFn(params) ? children : renderNoAccess();
            }}
        </AccessConsumer>
    );
};

AccessControl.defaultProps = {
    renderNoAccess: f => f
};

AccessControl.propTypes = {
    children: PropTypes.element,
    params: PropTypes.object,
    renderNoAccess: PropTypes.func,
    rule: PropTypes.string
};

export default AccessControl;
